export default (graphComponentRef, groupId) => {
    var _a, _b;
    return (_b = (_a = graphComponentRef.current) === null || _a === void 0 ? void 0 : _a.graph) === null || _b === void 0 ? void 0 : _b.nodes.find(item => Boolean(item.tag && item.tag.Nodes && item.tag.GroupId && item.tag.GroupId === groupId));
};
